export const ROL_SUPERADMIN = 4;
export const ROL_ADMIN = 3;
export const ROL_SELLER = 2;
export const ROL_USER = 2;
// export const SERVICE_URL = 'http://localhost:6300';
export const SERVICE_URL = 'https://gestion.policiaguancha.com/api';
export const ALLOW_USER_ROLES = [ROL_SUPERADMIN, ROL_ADMIN, ROL_USER];
export const APIGEOLOCATION_STREETTOCOORD = 'pk.2ad7e6a422776762a8ad3fccd7835e08';
export const CENTERCOORDS = {
    lat: 28.3749,
    lon: -16.652
};
export const MAPBOXACCESSTOKEN = 'pk.eyJ1IjoianJlaW5hMTAiLCJhIjoiY2w0Y3QxanJmMDFuYjNlbW03eXdncGUxdyJ9.BGXu7jWfZjlNx7htzk-dwQ';
export const DEFAULTMAPCENTER = [];
export const DEFAULTMAPZOOM = 15;
export const MAPBOXSTYLE = 'mapbox://styles/mapbox/streets-v11';
export const REGISTERSINTOOUT = '44d1f3b8-c794-49d2-827c-4ded5474db62';
export const REGISTERSEXTERNALANTECEDENTS = '90fa4c86-5f98-405d-ab13-50c599830295';
export const REGISTERSUNIDENTIFIEDPERSON = 'c1e21864-b39d-4126-81c7-0736c28c133c';
export const REGISTERSCITATIONS = '48c3ab98-d90c-4015-8f61-6869cbe94193';
export const REGISTERSDETAINED = 'e68cc6ae-e0ed-4564-aa14-312a446cbf03';
export const REGISTERSLOSTOBJECTS = '86650581-08ba-4111-aaef-64a2797a40bc';
